import { Spinner } from 'react-bootstrap'
import cn from 'classnames'
import s from './TripleGrow.module.scss'

interface Props {
  className?: string
  style?: React.CSSProperties
}

const defaultProps: Partial<Props> = {
  className: undefined,
  style: {},
}

const TripleGrow = ({ className, ...otherProps }: Props): JSX.Element => (
  <div
    className={cn('triple-grow', className)}
    data-testid="triple-grow"
    {...otherProps}
  >
    <Spinner className={s.spinner} animation="grow" />
    <Spinner className={s.spinner} animation="grow" />
    <Spinner className={s.spinner} animation="grow" />
  </div>
)

TripleGrow.defaultProps = defaultProps
export default TripleGrow
